<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">报警点名称：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">关联设备：</span>
        </div>
        <el-select v-model="formData.deviceName"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请选择关联设备">
          <el-option v-for="item in equipmentList" :key="item.deviceCode"
                     :label="item.deviceName" :value="item.deviceCode">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" />
      </div>
    </form>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { bus } from "../../../utils/bus";
import { api } from "../../api/CustomerFlow";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "police-point-management-modify",
  data() {
    return {
      breadcrumb: [
        {
          value: "视频报警",
          name: "video-alarm-over-view"
        },
        {
          value: "报警点管理"
        }
      ],
      mainTitle: "修改报警点",
      subheading: "",
      formData: {},
      equipmentCode: "",
      equipmentList: []
    };
  },
  created() {
    this.getMonitorPointByCode();
    this.remoteMethod();
  },
  methods: {
    remoteMethod() {
      this.getVideoDeviceList();
    },
    confirm() {
      if (!this.formData.name) {
        nError("请输入报警点名称");
        return false;
      }
      if (!this.formData.deviceCode) {
        nError("请选择关联设备");
        return false;
      }
      this.$axios
        .post(api.updateMonitorPoint, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.$router.push({
              name: "police-point-management"
            });
          }
        })
        .catch(errorHandler("修改失败"));
    },
    cancel() {
      this.$router.push({
        name: "police-point-management"
      });
    },
    getVideoDeviceList() {
      this.$axios
        .post(api.getVideoDeviceList, { purpose: "客流统计" })
        .then(res => {
          this.equipmentList = res.data.data;
        })
        .catch(errorHandler("获取列表失败"));
    },
    getMonitorPointByCode() {
      this.$axios
        .get(api.getMonitorPointByCode + "/" + this.$route.params.id)
        .then(res => {
          this.formData = res.data.data;
        })
        .catch(errorHandler("获取详情失败"));
    }
  },
  watch: {
    "formData.deviceName"(val) {
      this.equipmentList.map(v => {
        if (v.deviceCode == val) {
          this.formData.deviceCode = v.deviceCode;
          this.formData.deviceName = v.deviceName;
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/VideoAlarm/PolicePointManagement/PolicePointManagementModify.vue